import { useContext } from "react";
import {
  AmeaInfrastructureContext,
  AmeaRoutesDataContext,
  EnvironmentalDataContext,
  MeteoInfoDataContext,
  WeatherDataContext,
  IndexesDataContext,
  AllSensorsDataContext,
  AmeaInfrastructureFiltersContext,
  SensorTypesDataContext,
  NewRouteContext,
  ParkingDataContext,
} from "./context";

export const useAllContexts = () => {
  const ameaInfrastructures = useContext(AmeaInfrastructureContext);
  const ameaRoutes = useContext(AmeaRoutesDataContext);
  const ameaFilters = useContext(AmeaInfrastructureFiltersContext);
  const environment = useContext(EnvironmentalDataContext);
  const meteo = useContext(MeteoInfoDataContext);
  const weather = useContext(WeatherDataContext);
  const indexes = useContext(IndexesDataContext);
  const allSensors = useContext(AllSensorsDataContext);
  const sensorTypes = useContext(SensorTypesDataContext);
  const newRouteData = useContext(NewRouteContext);
  const parking = useContext(ParkingDataContext);

  return {
    ameaInfrastructures,
    ameaRoutes,
    ameaFilters,
    environment,
    meteo,
    weather,
    indexes,
    allSensors,
    sensorTypes,
    newRouteData,
    parking,
  };
};
